import classNames from 'classnames';
import { memo } from 'react';
import css from './Text.module.scss';

interface ComponentProps {
    /**
     * Text to display
     */
    children: any;
    /**
     * Classname to apply
     */
    className?: string;
    /**
     * Text transform to apply to heading text.
     *
     * Defaults
     * Heading* = undefined
     * ErrorText = undefined
     */
    textTransform?: React.CSSProperties['textTransform'];
    /**
     * Text transform to apply to heading text.
     *
     * Defaults
     * Heading* = 'bold'
     * ErrorText = 'normal'
     */
    fontWeight?: React.CSSProperties['fontWeight'];
}

export const Heading1Text: React.FC<ComponentProps> = memo(({ fontWeight = 'bold', ...props }) => {
    return (
        <div
            className={classNames(css.heading1, props.className)}
            style={{
                textTransform: props.textTransform,
                fontWeight: fontWeight,
            }}
        >
            {props.children}
        </div>
    );
});

export const Heading2Text: React.FC<ComponentProps> = memo(({ fontWeight = 'bold', ...props }) => {
    return (
        <div
            className={classNames(css.heading2, props.className)}
            style={{
                textTransform: props.textTransform,
                fontWeight: fontWeight,
            }}
        >
            {props.children}
        </div>
    );
});

export const Heading3Text: React.FC<ComponentProps> = memo(({ fontWeight = 'bold', ...props }) => {
    return (
        <div
            className={classNames(css.heading3, props.className)}
            style={{
                textTransform: props.textTransform,
                fontWeight: fontWeight,
            }}
        >
            {props.children}
        </div>
    );
});

export const Heading4Text: React.FC<ComponentProps> = memo(({ fontWeight = 'bold', ...props }) => {
    return (
        <div
            className={classNames(css.heading4, props.className)}
            style={{
                textTransform: props.textTransform,
                fontWeight: fontWeight,
            }}
        >
            {props.children}
        </div>
    );
});

export const ErrorText: React.FC<ComponentProps> = memo(({ fontWeight = 'normal', ...props }) => {
    return (
        <div
            className={classNames(css.error, props.className)}
            style={{
                textTransform: props.textTransform,
                fontWeight: fontWeight,
            }}
        >
            {props.children}
        </div>
    );
});